var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('request-form',{attrs:{"model":_vm.request},on:{"submit":_vm.submit,"favouriteAdded":_vm.updateFavourites,"favouriteRemoved":_vm.updateFavourites}})}
var staticRenderFns = []

export { render, staticRenderFns }